// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import polyfill from 'babel-polyfill';
import 'url-search-params-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import Cookie from 'js-cookie';
import Moment from 'moment';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$moment = Moment; //时间处理库

function refresh(to, next, isFromOld = false) {
  let dispatchResult = null;
  if (isFromOld) {
    const matchArray = location.hash.match(/userToken=(.+?)(&|$)/);
    dispatchResult = store.dispatch('FromOldFramework', matchArray[1]);
    window.sessionStorage.setItem('schoolSignupIsLogin', 1);
  } else {
    const hashToken = location.hash.match(/token=(.+?)(&|$)/);
    if (hashToken && hashToken[1]) {
      Cookie.set('Admin-Token', hashToken[1]);
    }
    dispatchResult = store.dispatch('GetInfo');
  }
  dispatchResult.then(() => { // 拉取user_info

    if (to.meta.permissionPath) {
      if (store.getters.permission.indexOf(to.meta.permissionPath) === -1) {
        next('/404');
      } else {
        next();
      }
    } else {
      next();
    }
  }).catch(error => {
    setTimeout(() => {
      next('/');
    }, 1000);
  });

}

router.beforeEach((to, from, next) => {
  if (to.path === '/main/homepage') {
    if (to.query.userToken) {
      refresh(to, next, true);
    } else {
      refresh(to, next, false);
    }
  } else {
    const whiteList = ['/login', '/', '/demo', '/infoSetIndex'];
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next();
    } else {
      if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
        refresh(to, next);
      } else {
        if (to.meta.permissionPath) {
          if (store.getters.permission.indexOf(to.meta.permissionPath) === -1) {
            // next('/404');
          } else {
            next();
          }
        } else {
          next();
        }
      }
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});





// WEBPACK FOOTER //
// ./src/main.js